import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'
import { i18n } from '@/i18n'; // 导入全局i18n实例
// import Cookies from 'js-cookie'
// import VueI18n from 'vue-i18n'

// import japan from './i18n/japan'
// import tc from './i18n/tc'
// import korean from './i18n/korean'

Vue.use(Vuex)
Vue.use(VueMeta)
// 自定义点击指令
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // 确保点击的是外部
      if (!(el === event.target || el.contains(event.target))) {
        // 调用指令绑定的表达式
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created() {
    if (process.env.NODE_ENV === 'production'){
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        let basePath = 'https://www.wildcaly.com/';
        let url = window.location.href; // 获取当前的 URL
        let parts = url.split('www.wildcaly.com/'); // 使用 '/sea/' 分割 URL
        let lang = parts[1].split('/')[0] || 'tw'; // 获取第二部分的第一个元素，即 'kr'
        let path = lang + '/m/index.html';
        window.location.href = `${basePath}${path}`;
      }
    }
  }
}).$mount('#app')
